import { ArrowLeftIcon } from "lucide-react";
import React, { useEffect, useRef, useState } from "react";

interface IModalProps {
  isOpen: boolean;
  setISOpen: (isOpen: boolean) => void;
  title: string;
  content: React.ReactNode;
  className?: string;
  showBackButton?: boolean;
  onBackButtonClick?: () => void;
}

const Modal = (props: IModalProps) => {
  const dialogRef = useRef<HTMLDialogElement | null>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (props.isOpen) {
      setIsVisible(true);
      dialogRef.current?.showModal();
    } else {
      setIsVisible(false);
      const timeout = setTimeout(() => {
        dialogRef.current?.close();
      }, 300);

      return () => clearTimeout(timeout);
    }
  }, [props.isOpen]);

  if (!props.isOpen && !isVisible) return null;

  return (
    <dialog
      ref={dialogRef}
      className={`fixed inset-0 z-[9000] flex items-center justify-center w-screen h-screen bg-black/60 transition-opacity duration-300 ${
        isVisible ? "opacity-100" : "opacity-0"
      }`}
    >
      <div
        className={`relative rounded-lg overflow-hidden z-[9001] bg-[#F7F7F7] min-w-[90%] lg:min-w-fit max-h-[90%] text-left shadow-xl transition-transform duration-300 ${
          isVisible ? "scale-100" : "scale-95"
        } ${props.className}`}
      >
        {/* Header */}
        <div className="w-full py-2 rounded-t-lg px-6 bg-[#333333] flex justify-between gap-2 items-center font-semibold text-primary text-lg">
          {props.showBackButton && props.onBackButtonClick && (
            <button
              onClick={props.onBackButtonClick}
              className="text-white hover:text-gray-50"
            >
              <ArrowLeftIcon className="h-6 w-6" />
            </button>
          )}
          <div className="flex-grow text-center text-[#999999]">
            {props.title}
          </div>
          <button
            onClick={() => props.setISOpen(false)}
            className="text-white hover:text-gray-400 text-lg outline-none"
          >
            &times;
          </button>
        </div>
        {/* <div className="border-t-2 mb-4"></div> */}
        <div className="overflow-y-auto max-h-[75vh]">{props.content}</div>
      </div>
    </dialog>
  );
};

export default Modal;
